module.exports = __webpack_public_path__ + "img/cate3.6098b7cb.png";